
import { 
  defineComponent, 
  computed, 
  SetupContext,
  PropType
} from "vue";
import { FavoriteHistoryRecipe, FavoriteSendedHistoryRecipe } from "@/types/favorites";
import CommonHorizontalRecipeList from "@/components/commonRecipe/CommonHorizontalRecipeList.vue";
import CommonRecipeList from "@/components/commonRecipe/CommonRecipeList.vue";
import NativeClient from "@/client/native-client";
import router from "@/router";
import { createFavoriteHistoryRecipesToCommonRecipes, createFavoriteSendedHistoryRecipesToCommonRecipes } from "@/utils/favorites-util";

export default defineComponent({
  name: "HistoryList",
  components: { CommonHorizontalRecipeList, CommonRecipeList },
  props: {
    /** 送信履歴 */
    sendedHistory: {
      type: Array as PropType<FavoriteSendedHistoryRecipe[]>,
      default: () => null
    },
    /** 閲覧履歴 */
    viewedHistory: {
      type: Array as PropType<FavoriteHistoryRecipe[]>,
      default: () => null
    }
  },
  setup(props, context: SetupContext) {
    const displaySendedList = computed(() => {
      if (props.sendedHistory == null) {
        NativeClient.sendDebugLog("HistoryList displaySendedList is null");
        return null;
      }
      NativeClient.sendDebugLog("HistoryList displaySendedList.count = " + props.sendedHistory.length);
      const displaySendedList = createFavoriteSendedHistoryRecipesToCommonRecipes(props.sendedHistory);
      NativeClient.sendDebugLog("HistoryList displaySendedList = " + JSON.stringify(displaySendedList));
      return displaySendedList;
    });
    const displayViewedList = computed(() => {
      if (props.viewedHistory == null) {
        NativeClient.sendDebugLog("HistoryList viewedHistory is null");
        return null;
      }
      NativeClient.sendDebugLog("HistoryList viewedHistory.count = " + props.viewedHistory.length);
      const displayViewedList = createFavoriteHistoryRecipesToCommonRecipes(props.viewedHistory);
      NativeClient.sendDebugLog("HistoryList displayViewedList = " + JSON.stringify(displayViewedList));
      return displayViewedList;
    });

    const viewedTitle = "閲覧履歴";
    const viewedMoreTitle = "もっと見る";
    const noViewedElementText = "閲覧履歴はありません";
    const sendedTitle = "送信履歴";
    const sendedMoreTitle = "もっと見る";
    const noDownloadElementText = "送信履歴はありません<br>家電登録後、機器にレシピ送信すると表示されます。";
    const registDeviceText = "家電登録へ";
    const selectRecipe = (recipeId: number, type: string) => {
      // 閲覧済レシピに遷移
      NativeClient.sendDebugLog("HistoryList recipeId = " + recipeId + ", type = " + type);
      NativeClient.transitionReceipDetail(recipeId, type);
    };
    const selectDisplayedList = () => {
      // 閲覧済レシピに遷移
      NativeClient.sendDebugLog("HistoryList transition displayed");
      router.push(`/historylist?kind=1`);
    };
    const selectDownloadList = (recipeId: number, type: string) => {
      // 送信済みレシピへ遷移
      NativeClient.sendDebugLog("HistoryList transition viewed");
      router.push(`/historylist?kind=0`);
    };
    const selectRegisterDevice = () => {
      // 家電登録へ
      NativeClient.sendDebugLog("HistoryList transition register device");
      NativeClient.transitionApplianceList();
    }

    // 表示／非表示制御
    const styleSendedMoreButton = computed(() => {
      NativeClient.sendDebugLog("HistoryList styleSendedMoreButton");
      if (props.sendedHistory == null) {
        NativeClient.sendDebugLog("HistoryList styleSendedMoreButton null branch");
        return { visibility: `hidden` };
      } else if (props.sendedHistory.length == 0) {
        return { visibility: `hidden` };
      }
      return { visibility: `visible` };
    });
    const styleSendedList = computed(() => {
      NativeClient.sendDebugLog("HistoryList styleSendedList");
      if (props.sendedHistory == null) {
        NativeClient.sendDebugLog("HistoryList styleSendedList null branch");
        return { display: `none` };
      } else if (props.sendedHistory.length == 0) {
        NativeClient.sendDebugLog("HistoryList styleSendedList no element branch");
        return { display: `none` };
      }
      return { display: `inline-box` };
    });
    const styleSendedListNoElement = computed(() => {
      NativeClient.sendDebugLog("HistoryList styleSendedListNoElement");
      if (props.sendedHistory == null) {
        NativeClient.sendDebugLog("HistoryList styleSendedListNoElement null branch");
        return { display: `inline-block`, visibility: `hidden` };
      } else if (props.sendedHistory.length == 0) {
        NativeClient.sendDebugLog("HistoryList styleSendedListNoElement no element branch");
        return { display: `inline-block`, visibility: `visible` };
      }
      NativeClient.sendDebugLog("HistoryList styleSendedListNoElement length = " + props.sendedHistory.length);
      return { display: `none` };
    });
    const styleViewedMoreButton = computed(() => {
      NativeClient.sendDebugLog("HistoryList styleViwedMoreButton");
      if (props.viewedHistory == null) {
        NativeClient.sendDebugLog("HistoryList styleViwedMoreButton null branch");
        return { visibility: `hidden` };
      } else if (props.viewedHistory.length == 0) {
        NativeClient.sendDebugLog("HistoryList styleViwedMoreButton no element branch");
        return { visibility: `hidden` };
      }
      return { visibility: `visible` };
    });
    const styleViewedList = computed(() => {
      NativeClient.sendDebugLog("HistoryList styleViewedList");
      if (props.viewedHistory == null) {
        NativeClient.sendDebugLog("HistoryList styleViewedList null branch");
        return { display: `none` };
      } else if (props.viewedHistory.length == 0) {
        NativeClient.sendDebugLog("HistoryList styleViewedList no element branch");
        return { display: `none` };
      }
      return { display: `block` };
    });
    const styleViewedListNoElement = computed(() => {
      NativeClient.sendDebugLog("HistoryList styleViewedListNoElement");
      if (props.viewedHistory == null) {
        NativeClient.sendDebugLog("HistoryList styleViewedListNoElement null branch");
        return { display: `table`, visibility: `hidden` };
      } else if (props.viewedHistory.length == 0) {
        NativeClient.sendDebugLog("HistoryList styleViewedListNoElement no element branch");
        return { display: `table`, visibility: `visible` };
      }
      return { display: `none` };
    });

    return {
      viewedTitle,
      viewedMoreTitle,
      noViewedElementText,
      sendedTitle,
      sendedMoreTitle,
      noDownloadElementText,
      registDeviceText,
      displaySendedList,
      displayViewedList,
      selectRecipe,
      selectDownloadList,
      selectDisplayedList,
      selectRegisterDevice,
      styleSendedMoreButton,
      styleSendedList,
      styleSendedListNoElement,
      styleViewedMoreButton,
      styleViewedList,
      styleViewedListNoElement
    };
  }
});
